<template>
  <div>
    <main class="report" id="section-print">
      <div class="header">
        <div class="left">
          <h2 class="report-title">TANDA TERIMA PENYERAHAN NOTA</h2>
        </div>
      </div>

      <div class="mt-4">
        <div class="invoice-info">
          <h3 class="mb-0 font-italic">
            Diserahkan Kepada: <span v-if="karyawan">{{ karyawan.text }}</span>
          </h3>
        </div>

        <div class="items mt-3">
          <table width="100%">
            <thead>
              <th>Nomor Nota</th>
              <th>Ditagih Kepada</th>
              <th>Tanggal Serah Nota</th>
            </thead>
            <tbody>
              <tr v-for="nota in data" :key="nota.id">
                <td class="text-center">{{ nota.nomor_nota }}</td>
                <td class="text-center">{{ nota.customer.nama_lengkap }}</td>
                <td class="text-center">
                  {{ formatDate(nota.tgl_serah_nota) }}
                </td>
              </tr>
            </tbody>
          </table>

          <div class="price d-flex justify-end mt-5 mb-5">
            <div>
              {{ port_awal }},
              {{ today }}
            </div>
          </div>
        </div>
      </div>
    </main>

    <v-row class="remove-print">
      <v-col cols="12" md="4" sm="4">
        <v-text-field
          label="Tanggal Serah Nota"
          type="date"
          dense
          outlined
          hide-details
          v-model="formData.tgl_serah_nota"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4" sm="4">
        <v-autocomplete
          label="Kolektor"
          dense
          outlined
          hide-details
          v-model="formData.nomor_karyawan"
          :items="items.kolektor"
          :loading="loading.fetchKolektor"
          :disabled="loading.fetchKolektor"
          @change="fetchData"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4" sm="4">
        <v-text-field
          label="Nomor Nota"
          type="text"
          outlined
          clearable
          dense
          v-model="formData.nomor_nota"
          :loading="loading.addPenyebaran"
          @keydown.enter="addPenyebaranNota"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4" sm="4">
        Nota Belum Lunas: {{ formatCurrency(nominal_belum_lunas) }}
      </v-col>
    </v-row>

    <v-data-table
      :loading="loading.fetchPenyebaran"
      :headers="headers"
      :items="data"
      :search="search"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-md-none my-5"></div>
        <v-icon @click="deletePenyebaran(item.id)"> mdi-delete </v-icon>
      </template>
      <template v-slot:item.nilai_nota="{ item }">
        {{ formatCurrency(item.nilai_nota) }}
      </template>
      <template v-slot:item.tgl_serah_nota="{ item }">
        {{ formatDate(item.tgl_serah_nota) }}
      </template>
      <template v-slot:item.lama="{ item }">
        {{ calculateDateBetween(item.tgl_serah_nota) }} Hari
      </template>
    </v-data-table>

    <div class="mt-5 mb-3">
      Nota Belum Lunas Hari Ini:
      {{ formatCurrency(nominal_belum_lunas_hari_ini) }}
    </div>
    <v-data-table
      :loading="loading.fetchPenyebaranHariIni"
      :headers="headers"
      :items="dataHariIni"
      :search="search"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-md-none my-5"></div>
        <v-icon @click="deletePenyebaran(item.id)"> mdi-delete </v-icon>
      </template>
      <template v-slot:item.nilai_nota="{ item }">
        {{ formatCurrency(item.nilai_nota) }}
      </template>
      <template v-slot:item.tgl_serah_nota="{ item }">
        {{ formatDate(item.tgl_serah_nota) }}
      </template>
      <template v-slot:item.lama="{ item }">
        {{ calculateDateBetween(item.tgl_serah_nota) }} Hari
      </template>
    </v-data-table>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      :disabled="!formData.nomor_karyawan"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      port_awal: JSON.parse(localStorage.getItem("port_awal")).text,
      loading: {
        addPenyebaran: false,
        fetchPenyebaran: false,
        fetchKolektor: false,
        fetchPenyebaranHariIni: false
      },
      formData: {
        tgl_serah_nota: "",
        nomor_karyawan: "",
        nomor_nota: ""
      },
      items: {
        kolektor: []
      },
      data: [],
      dataHariIni: [],
      search: "",
      nominal_belum_lunas: 0,
      nominal_belum_lunas_hari_ini: 0,
      headers: [
        { text: "Nama Kolektor", value: "nama_kolektor" },
        { text: "Ditagih Kepada", value: "customer.nama" },
        { text: "Nomor Nota", value: "nomor_nota" },
        { text: "Nilai Nota", value: "nilai_nota" },
        { text: "Tgl Serah Nota", value: "tgl_serah_nota" },
        { text: "Lama", value: "lama" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  watch: {
    "formData.nomor_nota"(val) {
      if (val) {
        this.formData.nomor_nota = val.toUpperCase();
      }
    }
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    karyawan() {
      return this.items.kolektor.find(el => {
        return el.value == this.formData.nomor_karyawan;
      });
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchData() {
      await this.fetchDataPenyebaran();
      await this.fetchDataPenyebaranHariIni();
    },
    async fetchKolektor() {
      this.loading.fetchKolektor = true;

      await axios
        .get(`kolektor`)
        .then(res => {
          this.items.kolektor = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.fetchKolektor = false;
        })
        .catch(err => {
          this.loading.fetchKolektor = false;

          alert(err.response.data.message);
        });
    },
    async fetchDataPenyebaran() {
      this.loading.fetchPenyebaran = true;

      await axios
        .get(
          `invoice/penyebaran-nota?kolektor_id=${this.formData.nomor_karyawan}`
        )
        .then(res => {
          this.data = res.data;
          this.nominal_belum_lunas = this.data.reduce(
            (acc, cur) => acc + cur.nilai_nota,
            0
          );

          this.loading.fetchPenyebaran = false;
        })
        .catch(err => {
          this.loading.fetchPenyebaran = false;

          alert(err.response.data.message);
        });
    },
    async fetchDataPenyebaranHariIni() {
      this.loading.fetchPenyebaranHariIni = true;

      await axios
        .get(
          `invoice/penyebaran-nota-hari-ini?kolektor_id=${this.formData.nomor_karyawan}`
        )
        .then(res => {
          this.dataHariIni = res.data;
          this.nominal_belum_lunas_hari_ini = this.dataHariIni.reduce(
            (acc, cur) => acc + cur.nilai_nota,
            0
          );

          this.loading.fetchPenyebaranHariIni = false;
        })
        .catch(err => {
          this.loading.fetchPenyebaranHariIni = false;

          alert(err.response.data.message);
        });
    },
    async addPenyebaranNota() {
      this.loading.addPenyebaran = true;

      await axios
        .post(`invoice/penyebaran-nota`, this.formData)
        .then(res => {
          this.formData.nomor_nota = "";
          this.fetchDataPenyebaran();
          this.fetchDataPenyebaranHariIni();

          this.loading.addPenyebaran = false;
        })
        .catch(err => {
          this.loading.addPenyebaran = false;

          alert(err.response.data.message);
        });
    },
    async deletePenyebaran(id) {
      await axios
        .delete(`invoice/penyebaran-nota/${id}`)
        .then(res => {
          this.fetchDataPenyebaran();
          this.fetchDataPenyebaranHariIni();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    calculateDateBetween(date1) {
      let date2 = new Date();
      let diffTime = Math.abs(date2 - new Date(date1));
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
    formatDate(data) {
      let date = new Date(data);
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  },
  created() {
    this.fetchKolektor();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.head {
  display: flex;
}

.mr-10 {
  margin-right: 15rem;
}

#section-print {
  display: none;
}

@media print {
  #section-print {
    display: inline-block;
  }
}
</style>
